import React from 'react'
import BtnGrid from './BtnGrid'
import data from '../../apps.json'
function AllApps() {
  return (
    <div className='UserDash-body'><BtnGrid Title='All apps' file={data['All']} no_data="No recently used"/></div>
  )
}

export default AllApps